import CategoryDropdown from "./CategoryDropdown";

const CategorySelectionSection = () => {
  const styles = {
    backgroundColor: "var(--color-bgFill-brand-subdued)",
    borderRadius: "4px",
    padding: "var(--space-medium)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "var(--space-medium)",
  }

  return (
    <div style={styles}>
      <span
        className={"type-body-bold-medium"}
        style={{flexBasis: "40%"}}
      >
        Choose List Type *
      </span>
      <div style={{flexBasis: "60%"}}>
        <CategoryDropdown />
      </div>
    </div>
  )
}

export default CategorySelectionSection;
